import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import { Link } from "gatsby"

import FacioLogoPrimary from "assets/logos/facio-primary.svg"
import FacioLogoAlternative from "assets/logos/facio-alternative.svg"

import Menu from "assets/menu.svg"
import Close from "assets/close.svg"

import styles from "./header.module.css"

const Header = ({ dark }) => {
  const [isOpen, setOpen] = useState(false)
  const [mobile, setMobile] = useState(false)

  useEffect(() => {
    function mobile() {
      setMobile(window.matchMedia("(max-width: 900px)").matches)
    }
    mobile()
    window.addEventListener("resize", mobile)
    return () => {
      window.removeEventListener("resize", mobile)
    }
  })

  return (
    <header className={`${styles.header} ${dark && styles.dark}`}>
      <div className="wrapper">
        <div className={styles.menu}>
          <Link to="/">
            {dark ? (
              <FacioLogoAlternative
                className={`${styles.logo} ${isOpen && styles.isOpen}`}
              />
            ) : (
              <FacioLogoPrimary
                className={`${styles.logo} ${isOpen && styles.isOpen}`}
              />
            )}
          </Link>
          {mobile && (
            <button onClick={() => setOpen(true)} className={styles.menuIcon}>
              <Menu alt="Ícone de menu" className={styles.icon} />
              <span>menu</span>
            </button>
          )}

          <nav
            className={[
              styles.linkList,
              mobile && styles.mobile,
              isOpen && styles.isOpen,
            ].join(" ")}
          >
            {mobile && (
              <button onClick={() => setOpen(false)} className={styles.close}>
                <Close alt="botão fechar" className={styles.icon} />
                <span>fechar</span>
              </button>
            )}
            <ul>
              <li>
                <Link to="/funcionarios">Funcionários</Link>
              </li>
              <li>
                <Link to="/empresas">Empresas</Link>
              </li>
              <li>
                <Link to="/sobre-a-facio">Sobre</Link>
              </li>
              <li>
                <Link className="btn ebook" to="/e-book">
                  Baixe o e-book
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  dark: PropTypes.bool,
}

Header.defaultProps = {
  dark: false,
}

export default Header
